var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"cursor-tab-wrapper"}},[_c('TerminalCursor',{attrs:{"charBeneath":_vm.charBeneath}}),_c('TerminalTabAutoComplete',{attrs:{"suggestions":_vm.suggestions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }